import {clickEvent} from "../../../webpack/modules/events";
import {showImageZoomPopup} from "../../../webpack/modules-optimized/popup-image-zoom";

clickEvent('#product-page .images-zoom-popup', true, function (element, event) {
    let target = event.target;
    if (target.classList.contains('open-ar-modal') || target.closest('.open-ar-modal')) return;
    let productId = element.closest('.product-scope').dataset.productId;
    let position = element.dataset.position;

    showImageZoomPopup(productId, Number(position));
});